const Theme = {
  body_background_color: '#e0e4ea',
  header_full_height: true,

  title_font: 'Montserrat',
  text_font: 'Montserrat',

  logo_image_url: 'terresdeseine.png',

  token_hidden: true,
  number_hidden: true,

  title_margin: '10px',
  
  button_color: '#7babc6',
  button_radius: 100,
  button_border_width: 2,
}

export default Theme
//  https://app.clickup.com/t/86dyd6amj